import React from 'react';
export default (
  <svg width="21px" height="13px" viewBox="0 0 21 13">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L32 0 32 32 0 32z" transform="matrix(0 1 1 0 -5 -10)" />
      <path
        d="M21.8533333,5.85333333 C21.16,5.16 20.04,5.16 19.3466667,5.85333333 L11.1866667,14.0133333 C10.4933333,14.7066667 10.4933333,15.8266667 11.1866667,16.52 L19.3466667,24.68 C20.04,25.3733333 21.16,25.3733333 21.8533333,24.68 C22.5466667,23.9866667 22.5466667,22.8666667 21.8533333,22.1733333 L14.9555556,15.2577778 L21.8533333,8.36 C22.5466667,7.66666667 22.5288889,6.52888889 21.8533333,5.85333333 Z"
        fill="#ADB5BD"
        fillRule="nonzero"
        transform="matrix(0 1 1 0 -5 -10)"
      />
    </g>
  </svg>
);
